import * as rnStart from './start.service.js';

import rhinoDevice from 'rhino/src/components/device/device.module';
import rnClient from 'rhino/src/core/client/client.module';
import rnHttp from 'rhino/src/core/http/http.module';
import rnInvitation from 'rhino/src/components/invitation/invitation.module';
import rnPreference from 'rhino/src/components/preferences/preferences.module';
import rnDeviceDetector from 'rhino/src/components/device/device.module';

export default angular.module('rhino.components.start', [
  rhinoDevice,
  rnClient,
  rnHttp,
  rnInvitation,
  rnPreference,
  rnDeviceDetector
])
  .factory(rnStart.name, rnStart.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/start/start.module.js